import { FPS_24 } from '@/App/remotion/constants';
import createStore from '@/stores/store';

// Define the minimum and maximum zoom levels
// Zoom level 1 will mean 1px = 1frame and 24 will mean 24px = 1frame
export const MIN_ZOOM_LEVEL = 120 / (60 * 5 * FPS_24);
export const MAX_ZOOM_LEVEL = 100;
export const DEFAULT_ZOOM_LEVEL = 1; // px/frame
export const ZOOM_STEP = 1;

// Create a store for the zoom level
export const zoomLevelStore = createStore<number>(DEFAULT_ZOOM_LEVEL);

/**
 * Set the zoom level to a specific value
 * @param value - The new zoom level value
 */
export function setZoomLevel(value: number) {
  // Ensure the zoom level is within the allowed range
  const clampedValue = Math.max(MIN_ZOOM_LEVEL, Math.min(MAX_ZOOM_LEVEL, value));
  zoomLevelStore.set(() => clampedValue);
}
